const AgentActionTypes = {
    LOAD_FILE_IMPORT: 'agent/load_file_import',
    NEXT_STEP: 'agent/next_step',
    PREV_STEP: 'agent/prev_step',
    CANCEL_IMPORT: 'agent/cancel_import',
    LOADING: 'agent/loading',
    UPDATE_DATA_IMPORT: 'agent/update_data_import',
  };
  
  export default AgentActionTypes;